import React from 'react';
import { Redirect, Route, Switch } from "react-router-dom";
import Navigation from "./Navigation";
import NotFound from "../containers/NotFound";
import Home from "../containers/Home";
import Project from "../components/Project";


const Routes = () => {

  return (
    <Switch>

      <Route path="/" exact component={Home} />

      {/* Hack for react-router-bootstrap LinkContainer to correctly apply the active class to the current Nav item
      * Any request to e.g. /project-category redirects to /project-category/1
      */}
      {Navigation.map(navItem => {
        return <Route
          path={`/${navItem.category}`}
          key={navItem.id}
          exact
          render={(props) => <Redirect to={`/${navItem.category}/1`} />}
        />
      })}


      {/* Actual routes with project id */}
      {Navigation.map(navItem => {
        return <Route
          path={`/${navItem.category}/:id`}
          key={navItem.id}
          render={(props) => <Project {...props} category={navItem.category} />}
        />
      })}

      <Route component={NotFound} />

    </Switch>
  );
}

export default Routes;


// WEBPACK FOOTER //
// ./src/routing/Routes.js